var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28541",
    "data-name": "\\uC0AC\\uAC01\\uD615 28541",
    width: 19.024,
    height: 17.646,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22299",
    "data-name": "\\uADF8\\uB8F9 22299",
    transform: "translate(-1259 -7696)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28542",
    "data-name": "\\uC0AC\\uAC01\\uD615 28542",
    width: 24,
    height: 24,
    transform: "translate(1259 7696)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22298",
    "data-name": "\\uADF8\\uB8F9 22298",
    transform: "translate(1261.488 7699.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22297",
    "data-name": "\\uADF8\\uB8F9 22297",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10322",
    "data-name": "\\uD328\\uC2A4 10322",
    d: "M27.918,50.767a.655.655,0,1,0,.655.655.655.655,0,0,0-.655-.655",
    transform: "translate(-23.766 -44.256)",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10323",
    "data-name": "\\uD328\\uC2A4 10323",
    d: "M78.026,50.234a.705.705,0,1,0,.705.705.705.705,0,0,0-.705-.705",
    transform: "translate(-67.404 -43.791)",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10324",
    "data-name": "\\uD328\\uC2A4 10324",
    d: "M16.479,0H2.545A2.545,2.545,0,0,0,0,2.545v8.27A2.545,2.545,0,0,0,2.545,13.36H7.467L9.141,17.3s.115.342.394.342h0c.279,0,.394-.342.394-.342L11.6,13.36h4.876a2.545,2.545,0,0,0,2.545-2.545V2.545A2.545,2.545,0,0,0,16.479,0M5.977,7.31A1.576,1.576,0,0,1,4.406,8.866a1.307,1.307,0,0,1-.946-.4v.273H2.322V4.043s-.005,0,0,0v0c.071.011,1.138,0,1.138,0v1.8C3.728,5.379,4.5,5.387,4.5,5.387A1.667,1.667,0,0,1,5.977,7.31m2-1.78V8.745H6.867V5.563c0-.433-.537-.553-.537-.553V3.888A1.541,1.541,0,0,1,7.981,5.531m2.641,3.337A1.8,1.8,0,0,1,8.754,7.148a1.8,1.8,0,0,1,1.868-1.719A1.8,1.8,0,0,1,12.49,7.148a1.8,1.8,0,0,1-1.868,1.719m6.1,0A1.589,1.589,0,0,1,15.083,10.5h-.5V9.443h.3s.7.064.689-1.01c0,0-.136.435-1.114.435a1.469,1.469,0,0,1-1.387-1.453V6.9a1.585,1.585,0,0,1,1.555-1.515,1.134,1.134,0,0,1,.97.433V5.475h1.13Z",
    transform: "translate(0 0)",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10325",
    "data-name": "\\uD328\\uC2A4 10325",
    d: "M111.916,50.359a.689.689,0,1,0,.689.689.689.689,0,0,0-.689-.689",
    transform: "translate(-96.962 -43.9)",
    fill: "#212529"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon4);
export default __webpack_public_path__ + "static/media/FooterIcon4.aecd7fdef94ffc1b4ae3593f86e98659.svg";
export { ForwardRef as ReactComponent };